import { c as _c } from "react/compiler-runtime";
import { Tabs } from '@algoacademy/design-system/web/navigation/Tabs';
export enum MENTORING_TABS {
  ADVANCED_MENTORING = 'Mentoring rozszerzony',
  BASIC_MENTORING = 'Mentoring podstawowy',
}
type MentoringTabsProps = {
  tabs: MENTORING_TABS[];
  activeTab: MENTORING_TABS;
  setActiveTab: React.Dispatch<React.SetStateAction<MENTORING_TABS>>;
  className?: string;
};
export function MentoringTabs(t0) {
  const $ = _c(8);
  const {
    tabs,
    activeTab,
    setActiveTab
  } = t0;
  let t1;
  if ($[0] !== tabs) {
    t1 = tabs.map(_temp);
    $[0] = tabs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== setActiveTab) {
    t2 = tab_0 => setActiveTab(tab_0 as MENTORING_TABS);
    $[2] = setActiveTab;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== activeTab || $[5] !== t1 || $[6] !== t2) {
    t3 = <Tabs tabs={t1} activeTab={activeTab} setActiveTab={t2} />;
    $[4] = activeTab;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp(tab) {
  return {
    label: tab
  };
}